import { useEffect } from "react";
import { Button } from "@/components/ui/button";

const EVENT_ID = "1988836397202";
const EXTERNAL_URL = `https://www.eventbrite.com/e/${EVENT_ID}?aff=oddtdtcreator`;
const WIDGET_SRC = "https://www.eventbrite.com/static/widgets/eb_widgets.js";

export default function EventbriteEmbed({ sectionId }) {
  useEffect(() => {
    // Load Eventbrite Widgets script once
    const existing = document.querySelector(`script[src="${WIDGET_SRC}"]`);
    const initWidget = () => {
      if (window.EBWidgets) {
        window.EBWidgets.createWidget({
          widgetType: "checkout",
          eventId: EVENT_ID,
          iframeContainerId: "eventbrite-widget-container-1988836397202",
          iframeContainerHeight: 700,
        });
      }
    };
    if (existing) {
      initWidget();
      return;
    }
    const s = document.createElement("script");
    s.src = WIDGET_SRC;
    s.async = true;
    s.onload = initWidget;
    document.body.appendChild(s);
  }, []);

  return (
    <section
      id={sectionId}
      data-testid="tickets-section"
      className="bg-emerald-50 py-20 sm:py-24 border-t border-b border-emerald-200"
    >
      <div className="mx-auto max-w-6xl px-6 lg:px-10">
        <div className="max-w-2xl mb-10">
          <div className="text-[11px] uppercase tracking-[0.3em] text-rose-600 font-[Outfit] font-bold">
            Purchase Tickets
          </div>
          <h2 className="font-[Cormorant_Garamond] text-4xl sm:text-5xl text-emerald-950 mt-3 leading-tight">
            VIP Experience &amp; Business Showers Celebration
          </h2>
          <p className="text-slate-700 font-[Outfit] mt-4 leading-relaxed">
            Reserve your seat for both the Friday, July 17 VIP Panel + Speed-Networking and
            the Saturday, July 18 Main Celebration. Secure checkout powered by Eventbrite.
          </p>
        </div>

        <div
          id="eventbrite-widget-container-1988836397202"
          data-testid="eventbrite-widget"
          className="bg-white rounded-2xl border border-emerald-200 overflow-hidden shadow-sm min-h-[700px]"
        />

        <div className="mt-6 flex flex-wrap items-center justify-between gap-4">
          <p className="text-sm text-slate-600 font-[Outfit]">
            Having trouble with the widget? Open Eventbrite directly:
          </p>
          <Button
            asChild
            data-testid="eventbrite-direct-link"
            className="rounded-full bg-emerald-800 hover:bg-emerald-900 text-white font-[Outfit] font-semibold"
          >
            <a href={EXTERNAL_URL} target="_blank" rel="noreferrer">
              Buy Tickets on Eventbrite →
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}

export { EXTERNAL_URL as EVENTBRITE_URL };
